<template>
  <div ref="boxRef" class="w-full">
    <slot name="default"></slot>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue'

interface IProps {
  height?: number
}
const props = withDefaults(defineProps<IProps>(), {
  height: 0
})

const boxRef = ref()

const settingFixedPage = () => {
  const workAreaHeight = (document.querySelector('.el-main') as HTMLElement)?.offsetHeight ?? 0
  const tableHeight = workAreaHeight - props.height
  boxRef.value.style.height = tableHeight + 'px'
}

const handleResize = () => {
  nextTick(() => {
    settingFixedPage()
  })
}

window.addEventListener('resize', handleResize)

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})

onMounted(() => {
  nextTick(() => {
    settingFixedPage()
  })
})
</script>

<style scoped></style>
